<template>
  <div class="container">
    <div class="banner">
      <img :src="reRecruitProject.webProjectPic" alt="" />
    </div>
    <!-- 搜索 -->
    <div
      ref="searchBar"
      :class="{ fixedTop: searchBarFixedTop }"
      class="search-wrapper"
    >
      <input-search
        :size="searchBarFixedTop ? 'small' : 'medium'"
        placeholder="搜索公司/职位"
        v-model="searchKeyword"
      ></input-search>
    </div>

    <div class="navigation">
      <!-- <div data-v-2a813751="" class="content-title">
          <div data-v-2a813751="" class="name">
            {{ reRecruitProject.projectName }}
          </div>
          <div data-v-2a813751="" class="hdmItem">
            共{{ reRecruitProject.count }}个岗位
          </div>
        </div> -->
      <ul class="job-tab">
        <li
          v-for="(item, index) in tabList"
          :key="index"
          class="tab-item"
          :class="{ 'item--active': index === tabCur }"
          @click="tabSelect(item.id)"
        >
          {{ item.title }}
          <span v-if="index == '0'">({{ reRecruitProject.companyCount }})</span>
          <span v-if="index == '1'">({{ reRecruitProject.count }})</span>
        </li>
      </ul>
    </div>

    <div class="main clearfix">
      <div
        class="content"
        v-loading:#ffffff7d.scrollFixed="loading"
        v-if="tabCur == '0'"
      >
        <ul class="content-list">
          <li
            class="recommend-company-item"
            v-for="(item, index) in companyList"
            :key="index"
          >
            <a
              :href="'/companyDetail/' + item.reCompanyId"
              target="_blank"
              class="company-t"
            >
              <img
                v-if="item.reCompanyLogo"
                :src="item.reCompanyLogo"
                alt=""
                class="company-logo1"
              />
              <div
                v-else
                class="company-title1"
                :style="{
                  backgroundColor: getColorById(item.reCompanyId),
                }"
              >
                {{ item.reCompanyName.slice(0, 4) }}
              </div>
              <div class="company-top-container">
                <div class="company-top">
                  {{ item.reCompanyName }}
                </div>
                <div class="company-bottom substring">
                  <span class="tag" v-if="item.industry">{{
                    item.industry
                  }}</span
                  ><span class="tag" v-if="item.enterpriseNature">{{
                    item.enterpriseNature
                  }}</span
                  ><span class="tag" v-if="item.enterpriseScale">{{
                    item.enterpriseScale
                  }}</span>
                  <span class="tag" v-if="item.groupName">{{
                    item.groupName
                  }}</span>
                </div>
              </div>
            </a>
          </li>
        </ul>
        <!-- 分页器 -->
        <div class="pagination-wrapper">
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="companyForm.pageNum"
            :limit.sync="companyForm.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
      <div
        class="content"
        v-loading:#ffffff7d.scrollFixed="loading"
        v-else-if="tabCur == '1'"
      >
        <ul class="content-list">
          <li
            class="recommend-job-item"
            v-for="(item, index) in jobsList"
            :key="index"
          >
            <a :href="'/jobDetail/' + item.jobId" target="_blank">
              <div class="job-top-container">
                <div class="job-top">
                  <div class="job-name">{{ item.job }}</div>
                  <div class="wage">{{ item.startSalary }}</div>
                </div>
                <div class="job-bottom substring">
                  <span class="tag" v-if="item.workingPlace">{{
                    item.workingPlace
                  }}</span
                  ><span class="tag" v-if="item.educationName">{{
                    item.educationName
                  }}</span
                  ><span class="tag" v-if="item.serviceName">{{
                    item.serviceName
                  }}</span>
                </div>
                <div class="job-bottom substring">
                  <span
                    v-for="(ite, i) in item.disabilities"
                    class="block"
                    :style="{ backgroundColor: getTagColor(ite) }"
                    >{{ ite }}</span
                  >
                </div>
              </div>
            </a>
            <div class="company-bottom">
              <div class="company-desc">
                <a
                  :href="'/companyDetail/' + item.companyId"
                  target="_blank"
                  class="company-t"
                >
                  <img
                    v-if="item.reCompanyLogo"
                    :src="item.reCompanyLogo"
                    alt=""
                    class="company-logo"
                  />
                  <div
                    v-else
                    class="company-title"
                    :style="{ backgroundColor: getColorById(item.companyId) }"
                  >
                    {{ item.companyName.slice(0, 4) }}
                  </div>
                  <div class="company-name substring">
                    {{ item.companyName }}
                  </div>
                </a>
              </div>
            </div>
          </li>
        </ul>
        <!-- 分页器 -->
        <div class="pagination-wrapper">
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="jobForm.params.pageNum"
            :limit.sync="jobForm.params.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getOffsetTop,
  getTagColor,
  getColorById,
  formatDisabilityData,
} from "@/helper/utilities";
let positionY = 0;
let searchBarClientHeight = 0;
import {
  getJobsList,
  getProjectCompanyList,
  getSingleRecruitProject,
  getPreviewUrl,
  getDisabledStatus,
} from "@/api/index";
import { groupBy } from "lodash";
export default {
  name: "zoneDetails",
  data() {
    return {
      reRecruitProject: "",
      tabCur: 0, // 当前tabs下标
      tabList: [
        {
          id: 0,
          title: "企业",
        },
        {
          id: 1,
          title: "职位",
        },
      ],
      // 查询参数
      searchKeyword: "",
      currentPage: 1,
      total: 0,
      searchBarFixedTop: false,
      loading: false,
      jobsList: [],
      companyList: [],
      companyForm: {
        pageNum: 1,
        pageSize: 10,
        reCompanyNameLike: "",
        reRecruitProjectId: "",
      },
      jobForm: {
        params: {
          pageNum: 1,
          pageSize: 10,
        },
        search: "",
        reRecruitProjectId: "",
      },
    };
  },
  watch: {
    searchKeyword(newVal, oldVal) {
      this.searchBarFixedTop && window.scrollTo(0, positionY);
      this.getList();
    },
  },
  mounted() {
    this.$nextTick(() => {
      positionY = getOffsetTop(document.body, this.$refs.searchBar);
      searchBarClientHeight = this.$refs.searchBar.clientHeight;
    });
    const onPageScroll = () => {
      const top = this.$refs.searchBar.getBoundingClientRect().top;
      this.searchBarFixedTop =
        window.scrollY > positionY - searchBarClientHeight / 2;
    };
    window.addEventListener("scroll", onPageScroll);

    this.$on("hook:destroyed", () => {
      window.removeEventListener("scroll", onPageScroll);
    });
  },
  created() {
    this.reRecruitProjectId = this.$route.query.id;
    this.title = this.$route.query.title;
    this.SingleRecruitProject(this.reRecruitProjectId);
    this.getList();
  },
  methods: {
    getTagColor,
    getColorById,
    //获取项目详情
    SingleRecruitProject(reRecruitProjectId) {
      getSingleRecruitProject(reRecruitProjectId).then((res) => {
        if (res.code == 200) {
          this.PreviewUrl(res.data);
        }
      });
    },

    PreviewUrl(item) {
      getPreviewUrl(item.webProjectPic).then((response) => {
        item.webProjectPic = response.msg;
        this.reRecruitProject = item;
      });
    },

    tabSelect(index) {
      this.tabCur = index;
      this.searchKeyword = null;
      // this.getList();
    },

    getList() {
      const loading = this.$loading();
      if (this.tabCur == "0") {
        (this.companyForm.reCompanyNameLike = this.searchKeyword),
          (this.companyForm.reRecruitProjectId = this.reRecruitProjectId),
          getProjectCompanyList(this.companyForm)
            .then((res) => {
              if (res.code == 200) {
                loading.close();
                this.companyList = res.data; //追加新数据
                this.companyList.forEach(async (item, i) => {
                  if (item.reCompanyLogo) {
                    await this.PreviewCompanyLogoUrl(item.reCompanyLogo, i);
                  }
                });
                this.total = res.total;
              }
            })
            .catch(() => {
              loading.close();
            });
      } else if (this.tabCur == "1") {
        this.jobForm.search = this.searchKeyword;
        this.jobForm.reRecruitProjectId = this.reRecruitProjectId;
        getJobsList(this.jobForm)
          .then(async (res) => {
            loading.close();
            // 1. 提取所有 jobId
            let jobIds = res.data.map((item) => item.jobId);
            // 2. 根据 jobIds 异步获取残疾标签数据
            await this.fetchDisabilityLabels(res.data, jobIds);
            this.total = res.total;
          })
          .catch(() => {
            loading.close();
          });
      }
    },

    //3，获取对应数据的残疾标签
    fetchDisabilityLabels(dataList, jobIds) {
      if (jobIds.length > 0) {
        getDisabledStatus(jobIds).then((res) => {
          const result = {};
          Object.keys(res.data).forEach((jobId) => {
            const grouped = groupBy(res.data[jobId], "disabledType");
            result[jobId] = Object.entries(grouped).map(([type, items]) => ({
              disabledType: type,
              disabledLevel: [
                ...new Set(items.map((item) => item.disabledLevel)),
              ],
            }));
          });

          const formattedData = formatDisabilityData(result);
          this.jobsList = dataList.map((job, i) => {
            if (job.reCompanyLogo) {
              this.PreviewLogoUrl(job.reCompanyLogo, i);
            }
            // 找到当前jobId对应的残疾数据
            const disabilities = formattedData[job.jobId] || [];
            return {
              ...job,
              disabilities, // 将残疾数据添加到职位对象中
            };
          });
        });
      }
    },

    //获取公司logo
    async PreviewCompanyLogoUrl(reCompanyLogo, i) {
      await getPreviewUrl(reCompanyLogo).then((response) => {
        this.companyList[i].reCompanyLogo = response.msg;
      });
    },

    //获取岗位列表公司logo
    async PreviewLogoUrl(reCompanyLogo, i) {
      await getPreviewUrl(reCompanyLogo).then((response) => {
        this.jobsList[i].reCompanyLogo = response.msg;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.banner {
  display: flex;
  flex-direction: column;
  min-width: @main-width;
  min-height: 350px;
  img {
    width: 100%;
    max-height: 500px;
  }
}

.search-wrapper {
  // position: absolute;
  width: 100%;
  // padding: 0 200px;
  // transform: translateY(-50%);
  margin-top: -25px;
  z-index: 100;
  &.fixedTop {
    position: fixed;
    box-shadow: 0 5px 4px rgba(0, 0, 0, 0.1);
    top: 25px;
    padding: 20px 130px;
    z-index: 1000;
    background-color: #fff;
    transform: translateY(0);
  }
}

.navigation {
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-top: -200px;
  z-index: 1;

  .content-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 2;
    width: @main-width;
    margin: 0 auto;
    .name {
      white-space: pre-wrap;
      text-align: center;
      margin-bottom: 10px;
      font-weight: 600;
      font-size: 30px;
      color: rgb(51, 51, 51);
      line-height: 40px;
      position: relative;
      font-style: normal;
    }
    .hdmItem {
      font-size: 20px;
    }
  }
  .job-tab {
    -ms-flex-align: center;
    -ms-flex-pack: center;
    align-items: center;
    cursor: pointer;
    display: -ms-flexbox;
    display: flex;
    height: 60px;
    justify-content: center;
    line-height: 60px;
    margin-bottom: 20px;
    margin-top: 1%;
    text-align: center;
    .tab-item {
      color: #333;
      font-size: 22px;
      margin: 0 40px;
      width: 128px;
      position: relative;
    }
    .tab-item.item--active {
      color: #00a0e9;
    }
    .tab-item.item--active:after {
      background: #00a0e9;
      bottom: 0;
      content: "";
      height: 4px;
      left: calc(50% - 10px);
      position: absolute;
      width: 20px;
    }
  }
}

.main {
  width: @main-width;
  margin: 0 auto;
  .recommend-company-item:nth-child(2n) {
    margin-right: 0;
  }
  .recommend-company-item {
    background-color: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    margin-bottom: 21px;
    margin-right: 20px;
    padding: 13px 25px;
    width: 45%;
  }

  .company-top-container {
    line-height: 30px;
  }

  .recommend-job-item:nth-child(2n) {
    margin-right: 0;
  }
  .recommend-job-item {
    background-color: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    margin-bottom: 21px;
    margin-right: 20px;
    padding: 13px 25px;
    width: 45%;
  }
  .pagination-wrapper {
    text-align: center;
  }
}
</style>